import React from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "components/ui";
import { formatCamelCase } from "utils/formateText";

const LifeStyle = ({ lifeStyleInfo }) => {
  return (
    <div>
      <Card className="min-w-full">
        <CardHeader>
          <CardTitle>Lifestyle</CardTitle>
        </CardHeader>
        <CardContent className="kt-scrollable-x-auto pb-3 p-0">
          <Table className="align-middle text-sm text-muted-foreground">
            <TableBody>
              <TableRow>
                <TableCell className="w-[40px] text-secondary-foreground font-normal text-left">
                  Sleep Schedule
                </TableCell>
                <TableCell className="w-28 text-[#2d2a33] font-semibold text-right">
                  {lifeStyleInfo?.sleep_schedule
                    ? formatCamelCase(lifeStyleInfo?.sleep_schedule)
                    : "N/A"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="w-[40px] text-secondary-foreground font-normal text-left">
                  Usually prefer to
                </TableCell>
                <TableCell className="w-28 text-[#2d2a33] font-semibold text-right">
                  {lifeStyleInfo?.prefer_to
                    ? formatCamelCase(lifeStyleInfo?.prefer_to)
                    : "N/A"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="w-[40px] text-secondary-foreground font-normal text-left">
                  Lifestyle
                </TableCell>
                <TableCell className="w-28 text-[#2d2a33] font-semibold text-right">
                  {lifeStyleInfo?.lifestyle
                    ? Number(lifeStyleInfo?.lifestyle).toFixed(2)
                    : "N/A"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="w-[40px] text-secondary-foreground font-normal text-left">
                  Fitness
                </TableCell>
                <TableCell className="w-28 text-[#2d2a33] font-semibold text-right">
                  {lifeStyleInfo?.fitness
                    ? Number(lifeStyleInfo?.fitness)
                    : "N/A"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="w-[40px] text-secondary-foreground font-normal text-left">
                  Mindset
                </TableCell>
                <TableCell className="w-28 text-[#2d2a33] font-semibold text-right">
                  {lifeStyleInfo?.mindset
                    ? Number(lifeStyleInfo?.mindset)
                    : "N/A"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="w-[40px] text-secondary-foreground font-normal text-left">
                  {"Don't want kids"}
                </TableCell>
                <TableCell className="w-28 text-[#2d2a33] font-semibold text-right">
                  {lifeStyleInfo?.want_kids === true ? "Yes" : "No"}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
};

export default LifeStyle;
